const POLICY = 'Policy';
const SIGNATURE = 'Signature';
const KEY_PAIR_ID = 'Key-Pair-Id';

export const validParams = [POLICY, SIGNATURE, KEY_PAIR_ID];

const asLowerCase = new Set(validParams.map(x => x.toLowerCase()));

export function getValidParams(
  url: string | undefined
): { [key: string]: string } {
  const params: { [key: string]: string } = {};
  if (!url) {
    return params;
  }

  const query: string = url.indexOf('://') > 0 ? new URL(url).search : url;
  if (!query) {
    return params;
  }

  const searchParams = new URLSearchParams(query);
  for (const [key, value] of searchParams) {
    if (asLowerCase.has(key.toLowerCase())) {
      params[key] = value;
    }
  }

  return params;
}
